/* eslint-disable max-lines */
import { saveUsers } from 'actions/users';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getCustomerDomain } from 'selectors/auth';
import { getNavParams } from 'selectors/nav';
import getUsers from 'selectors/userPermissionsPage';
import { useSelector } from 'store';
import { useHistory } from 'utils/urls';

const UsersPermissionsHeader: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { from_import: fromImport } = useSelector(getNavParams) as { from_import: string };
  const customerDomain = useSelector(getCustomerDomain);

  const users = useSelector(getUsers);

  const handleConfirmSave = (): void => {
    if (fromImport === 'true') {
      history.pushLookup({ routeName: 'customer-import', customerDomain });
    } else {
      dispatch(
        saveUsers({
          users,
          redirect: true,
          fromPermissionsPage: true,
        })
      );
    }
  };

  return (
    <header className="flex flex-row justify-between items-center px-6">
      <span className="w-full text-heading-1">New Users</span>
      <button
        type="button"
        className="button button--primary whitespace-no-wrap h-8"
        onClick={handleConfirmSave}
      >
        Save & Exit
      </button>
    </header>
  );
};

export default UsersPermissionsHeader;
